import { z } from 'zod';

export const zodDeleteContractImportJobEndpointSchema = z.tuple([
  z.literal('contracts'),
  z.literal('import_jobs'),
  z.uuid(),
]);
